import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useEquipmentInstances } from "@/hooks/useEquipmentInstances";
import { useInstancesSimCounts } from "@/hooks/useSims";
import { DeviceSimPanel } from "./DeviceSimPanel";

/** SIM panels for every instance of one equipment (equipment detail page). */
export function EquipmentSimsTab({
  equipmentId,
  equipmentName,
}: {
  equipmentId: string;
  equipmentName: string;
}) {
  const { data: instances = [], isLoading } =
    useEquipmentInstances(equipmentId);
  const counts = useInstancesSimCounts(instances.map((i) => i.id));
  const withSims = instances.filter((i) => (counts.get(i.id) ?? 0) > 0);
  const withoutSims = instances.filter((i) => !counts.get(i.id));

  if (isLoading) {
    return <p className="text-sm text-muted-foreground">Loading…</p>;
  }

  return (
    <div className="space-y-4" data-testid="equipment-sims-tab">
      {withSims.length === 0 && (
        <p className="text-sm text-muted-foreground">
          No SIMs assigned to any instance yet.
        </p>
      )}
      {withSims.map((instance) => {
        const name = `${equipmentName} ${instance.identifier}`;
        return (
          <Card key={instance.id}>
            <CardHeader className="pb-3">
              <CardTitle className="text-base">{name}</CardTitle>
            </CardHeader>
            <CardContent>
              <DeviceSimPanel instanceId={instance.id} deviceName={name} />
            </CardContent>
          </Card>
        );
      })}
      {withoutSims.length > 0 && (
        <p className="text-xs text-muted-foreground">
          Without SIMs: {withoutSims.map((i) => i.identifier).join(", ")}
        </p>
      )}
    </div>
  );
}
